import { render, staticRenderFns } from "./Document.vue?vue&type=template&id=2494e4ce"
import script from "./Document.vue?vue&type=script&lang=ts"
export * from "./Document.vue?vue&type=script&lang=ts"
import style0 from "./Document.vue?vue&type=style&index=0&id=2494e4ce&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports